import RosterQrCodesPrint from './RosterQrCodesPrint';

export default RosterQrCodesPrint;
